import type { LintPlugins } from "#/@types/oxlint";

const PLUGIN_NEXT = [
    "nextjs",
] as const satisfies LintPlugins;

export { PLUGIN_NEXT };
